import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DgaAuthStatus } from "@obg/common.registration/sdk/telemetry/registration-telemetry.model";
import { OpenIdConnectProviders } from "@obg/common.verification";
import { GtmEventAction, GtmLoginMethod } from "@obg/gtm.types/adaptive";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { TelemetryService } from "@obg/ngx.global.evo";
import { filter, map, tap } from "rxjs/operators";

import { OPEN_ID_CONNECT_ACTION_TYPE } from "./open-id-connect.action";
import { OidcErrorPayload, OidcTokenPayload } from "./open-id-connect.model";

@Injectable()
export class OpenIdConnectTelemetryEffect {
	openIdConnectSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectToken),
				map((x: ActionWithPayload<OidcTokenPayload>) => x.payload),
				filter((payload) => payload.provider === OpenIdConnectProviders.MitId),
				tap(() => {
					this.telemetryService.track({
						RegistrationType: GtmLoginMethod.MitID,
						Status: DgaAuthStatus.Success,
						LoginMethod: GtmLoginMethod.MitID,
						event: GtmEventAction.MitIDClose,
					});
				})
			),
		{ dispatch: false }
	);

	openIdConnectFail$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(OPEN_ID_CONNECT_ACTION_TYPE.setOpenIdConnectError),
				map((x: ActionWithPayload<OidcErrorPayload>) => x.payload),
				filter((payload) => payload.provider === OpenIdConnectProviders.MitId),
				tap(() => {
					this.telemetryService.track({
						RegistrationType: GtmLoginMethod.MitID,
						Status: DgaAuthStatus.Failed,
						LoginMethod: GtmLoginMethod.MitID,
						event: GtmEventAction.MitIDClose,
					});
				})
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private telemetryService: TelemetryService
	) {}
}
